// src/components/Loader.js
import React from 'react';
import './index.css'; 

const Loader = () => (
  <div className="spinner-container">
    <div className="spinner" />
  </div>
);

export default Loader;
